import React, { useCallback } from 'react';
import { func, number, object, oneOfType, string } from 'prop-types';
import clsx from 'clsx';
import Chip from '@material-ui/core/Chip';

import defaultClasses from './Autocomplete.module.css';

const InputAdornment = ({
    classes,
    color,
    disabled,
    item,
    label,
    onClick,
    onDelete
}) => {
    const handleClick = useCallback(
        (event) => {
            if (disabled) {
                return;
            }
            onClick(item, event);
        },
        [item, onClick]
    );

    const handleDelete = useCallback(
        (event) => {
            if (disabled) {
                return;
            }
            onDelete(item, event);
        },
        [item, onDelete]
    );

    return (
        <Chip
            color={color}
            label={label}
            onClick={handleClick}
            onDelete={handleDelete}
            tabIndex={-1}
            classes={{
                colorPrimary: clsx(
                    defaultClasses.adornmentColorPrimary,
                    classes.colorPrimary,
                    {
                        [defaultClasses.adornmentDisabledColorPrimary]: disabled
                    }
                ),
                deleteIcon: clsx(
                    defaultClasses.adornmentDeleteIcon,
                    classes.deleteIcon,
                    {
                        [defaultClasses.adornmentDisabledDeleteIcon]: disabled
                    }
                ),
                label: clsx(
                    defaultClasses.adornmentLabel,
                    classes.label
                ),
                root: clsx(
                    defaultClasses.adornment,
                    classes.root,
                    {
                        [defaultClasses.adornmentDisabled]: disabled
                    }
                )
            }}
        />
    );
};


InputAdornment.defaultProps = {
    classes:  {},
    color:    'primary',
    onDelete: () => {}
};

InputAdornment.propTypes = {
    classes:  object,
    color:    string,
    item:     oneOfType([number, object, string]).isRequired,
    onDelete: func
};

export default InputAdornment;
